export const demoData = [
    {
        name: '测试1',
        key: 'test1',
        video: 'https://cloud.video.taobao.com/play/u/4230840428/p/1/e/6/t/1/226681287869.mp4'
    },
    {
        name: '返利',
        key: 'FanLi',
        video: 'https://yun-resource.nianchu.net/video/demo/%E8%BF%94%E5%88%A9.mp4'
    },
    {
        name: '财务管理',
        key: 'CaiWuGuanLi',
        video: 'https://yun-resource.nianchu.net/video/demo/%E8%B4%A2%E5%8A%A1%E7%AE%A1%E7%90%86.mp4'
    },
    {
        name: '插件设置',
        key: 'ChaJianSheZhe',
        video: 'https://yun-resource.nianchu.net/video/demo/%E6%8F%92%E4%BB%B6%E8%AE%BE%E7%BD%AE.mp4'
    },
    {
        name: '订单管理',
        key: 'DingDanGuanLi',
        video: 'https://yun-resource.nianchu.net/video/demo/%E8%AE%A2%E5%8D%95%E7%AE%A1%E7%90%86.mp4'
    },
    {
        name: '工作台',
        key: 'GongZuoTai',
        video: 'https://yun-resource.nianchu.net/video/demo/%E5%B7%A5%E4%BD%9C%E5%8F%B0.mp4'
    },
    {
        name: '回复设置',
        key: 'HuiFuSheZhi',
        video: 'https://yun-resource.nianchu.net/video/demo/%E5%9B%9E%E5%A4%8D%E8%AE%BE%E7%BD%AE.mp4'
    },
    {
        name: '会员管理',
        key: 'HuiYuanGuanLi',
        video: 'https://yun-resource.nianchu.net/video/demo/%E4%BC%9A%E5%91%98%E7%AE%A1%E7%90%86.mp4'
    },
    {
        name: '基础设置',
        key: 'JiChuSheZhi',
        video: 'https://yun-resource.nianchu.net/video/demo/%E5%9F%BA%E7%A1%80%E8%AE%BE%E7%BD%AE.mp4'
    },
    {
        name: '联盟配置',
        key: 'LianMengPeiZhi',
        video: 'https://yun-resource.nianchu.net/video/demo/%E8%81%94%E7%9B%9F%E9%85%8D%E7%BD%AE.mp4'
    },
    {
        name: '免单',
        key: 'MianDan',
        video: 'https://yun-resource.nianchu.net/video/demo/%E5%85%8D%E5%8D%95.mp4'
    },
    {
        name: '设备管理',
        key: 'SheBeiGuanLi',
        video: 'https://yun-resource.nianchu.net/video/demo/%E8%AE%BE%E5%A4%87%E7%AE%A1%E7%90%86.mp4'
    },
    {
        name:'小程序自定义封面',
        key:'MiniProgranmCustomCover',
        video:'https://yun-resource.nianchu.net/video/demo/%E5%B0%8F%E7%A8%8B%E5%BA%8F%E8%87%AA%E5%AE%9A%E4%B9%89%E5%B0%81%E9%9D%A2.mp4'
    }
]